import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Lock } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: 'linear-gradient(135deg, #0E2D43 0%, #123E58 42%, #167786 100%)' }}
    >
      <div className="w-full max-w-md px-4">
        <div
          className="bg-white p-10"
          style={{ borderRadius: 'var(--ph-radius-xxl, 32px)', boxShadow: '0 24px 70px rgba(15,23,42,0.16)' }}
        >
          {/* Logo */}
          <div className="text-center mb-8">
            <h1
              className="text-2xl font-bold"
              style={{ color: 'var(--ph-navy, #0E2D43)', fontFamily: 'var(--font-display, Libre Baskerville, serif)' }}
            >
              PREST'HYG
            </h1>
            <p className="text-xs mt-1 font-medium" style={{ color: 'var(--ph-slate500, #64748B)' }}>
              Logiciel HACCP Premium
            </p>
          </div>

          <form onSubmit={handleSubmit} data-testid="login-form">
            <div className="mb-5">
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: 'var(--ph-navy, #0E2D43)' }}
              >
                Adresse email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="email-input"
                placeholder="votre@email.com"
                className="w-full px-4 py-3 border text-sm focus:outline-none focus:ring-2"
                style={{
                  borderColor: 'var(--ph-slate200, #E2E8F0)',
                  borderRadius: 'var(--ph-radius-md, 16px)',
                  color: 'var(--ph-ink, #0B1720)',
                }}
                required
              />
            </div>

            <div className="mb-6">
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: 'var(--ph-navy, #0E2D43)' }}
              >
                Mot de passe
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="password-input"
                className="w-full px-4 py-3 border text-sm focus:outline-none focus:ring-2"
                style={{
                  borderColor: 'var(--ph-slate200, #E2E8F0)',
                  borderRadius: 'var(--ph-radius-md, 16px)',
                  color: 'var(--ph-ink, #0B1720)',
                }}
                required
              />
            </div>

            {error && (
              <div
                className="mb-5 p-3 text-sm font-medium"
                style={{ backgroundColor: '#FEF2F2', color: '#B91C1C', borderRadius: 'var(--ph-radius-sm, 12px)' }}
                data-testid="error-message"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-button"
              className="w-full py-3 text-sm font-semibold transition-all hover:opacity-90 disabled:opacity-50"
              style={{
                backgroundColor: 'var(--ph-navy, #0E2D43)',
                color: '#FFFFFF',
                borderRadius: 'var(--ph-radius-pill, 9999px)',
              }}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>

          {/* Secure message */}
          <div className="mt-6 flex items-center justify-center gap-2">
            <Lock size={13} style={{ color: 'var(--ph-slate500, #64748B)' }} />
            <p className="text-xs" style={{ color: 'var(--ph-slate500, #64748B)' }}>
              Acces reserve aux utilisateurs autorises
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
